import type { ContainerGuideActions } from '@tunein/web-api-client';
import type { ComponentType } from 'react';
import { ClearAllRecentsAction } from './ClearAllRecentsAction';
import css from './container-actions.module.scss';

// Container-level actions the api-client lifts onto `containerItem.actions` (see
// ContainerGuideActions / CONTAINER_ACTION_KEYS). Add an entry here to support a new one.
const actionComponents: Partial<Record<keyof ContainerGuideActions, ComponentType>> = {
  clearAllRecents: ClearAllRecentsAction,
};

interface ContainerActionsProps {
  actions?: ContainerGuideActions;
}

export function ContainerActions({ actions }: ContainerActionsProps) {
  const availableActions = (
    Object.keys(actionComponents) as Array<keyof ContainerGuideActions>
  ).filter((name) => actions?.[name]);

  if (!availableActions.length) {
    return null;
  }

  return (
    <div className={css.actionsRow} data-testid="containerActions">
      {availableActions.map((name) => {
        const Action = actionComponents[name] as ComponentType;

        return <Action key={name} />;
      })}
    </div>
  );
}
